/* eslint-disable react/require-default-props */
import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

interface Props {
  data?: Array<any>;
  days?: Array<any>;
  check: boolean;
  onChange: any;
  typeOperation: string;
  id: string | number;
  label?: string;
}

const CheckBox: React.FC<Props> = ({
  check, onChange, days, typeOperation, id, label, data,
}) => {
  const handleChange = (event: any) => {
    if (typeOperation === 'rules') {
      onChange(data?.map((item) => {
        if (item.codigo === id) {
          item.check = !item.check;
          return item;
        }
        return item;
      }));
      return;
    }
    if (typeOperation === 'day') {
      onChange(days?.map((item) => {
        if (item.idDiaDaSemana === id) {
          item.check = event.target.checked;
          return item;
        }
        return item;
      }));
    }
    if (typeOperation === 'period') {
      onChange(days?.map((item) => {
        if (item.idTurno === id) {
          item.check = event.target.checked;
          return item;
        }
        return item;
      }));
    }
  };
  return (
    <FormGroup>
      <FormControlLabel
        control={(
          <Checkbox
            size="small"
            color="primary"
            checked={check}
            onChange={handleChange}
            name="checkedA"
          />
)}
        label={label}
      />
    </FormGroup>
  );
};
export default CheckBox;
